import type { FC, PropsWithChildren } from 'react';
import React, { useContext } from 'react';

const ThreadInitContext = React.createContext(false);

interface Props {
  initialized: boolean;
}

export const ThreadInitProvider: FC<PropsWithChildren<Props>> = ({ children, initialized }) => {
  return <ThreadInitContext.Provider value={initialized}>{children}</ThreadInitContext.Provider>;
};

/**
 * This thread exists because, on mobile, we need to wait until the first set of messages have been registered before we can check if the editor must be auto-opened. Registration happens in a useEffect, which can sometimes run after the other useEffect that checks if the editor must be auto-opened.
 * The current implementation of the mobile footer editor requires the sections to be registered to open the editor to answer a message.
 */
export const useThreadInitContext = () => {
  return useContext(ThreadInitContext);
};
